import apiFetch from '@wordpress/api-fetch'

const form = document.querySelector('.js-form')
const emailReg = /^(([^<>()[]\.,;:s@]+(.[^<>()[]\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
if(form) {
  const success = form.querySelector('.form-success')
  const error = form.querySelector('.form-error')

  form.addEventListener('submit', (e) => {
    e.preventDefault()

    const organization = form.querySelector('#contact-organization')
    const name = form.querySelector('#contact-name')
    const lastname = form.querySelector('#contact-lastname')
    const email = form.querySelector('#contact-email')
    const phone = form.querySelector('#contact-phone')
    const message = form.querySelector('#contact-message')
    const rgpd = form.querySelector('#contact-rgpd')
    const contactEmail = form.querySelector('#contact-pref-email')
    const contactPhone = form.querySelector('#contact-pref-phone')
    
    let contactInfo = contactEmail.checked ? contactEmail.value : contactPhone.checked ? contactPhone.value : null
    let errors = ''
    let successes = ''

    //REMOVE
    success.style.display = 'none'
    error.style.display = 'none'
    success.innerHTML = ``
    error.innerHTML = ``
    let valid = true
    
    organization.classList.remove('is-error')
    name.classList.remove('is-error')
    lastname.classList.remove('is-error')
    email.classList.remove('is-error')
    phone.classList.remove('is-error')
    message.classList.remove('is-error')
    rgpd.classList.remove('is-error')
    contactEmail.classList.remove('is-error')
    contactPhone.classList.remove('is-error')

    if (!rgpd.checked) {
      rgpd.classList.add('is-error')
      errors = `You must validate the privacy policy`
      valid = false
    }

    if (!emailReg.test(email.value)) {
      email.classList.add('is-error')
      errors = `Email is not valid`
      valid = false
    }

    // TEST PHONE
    // TEST EMIAL

    // VIDE
    if (
      organization.value === '' ||
      name.value === '' ||
      lastname.value === '' ||
      email.value === '' ||
      message.value === ''
    ) {
      errors = `All fields are required`
      valid = false
    }
    if (organization.value === '' ) {
      organization.classList.add('is-error')
    }
    if (name.value === '' ) {
      name.classList.add('is-error')
    }
    if (lastname.value === '' ) {
      lastname.classList.add('is-error')
    }
    if (email.value === '' ) {
      email.classList.add('is-error')
    }
    if (message.value === '' ) {
      message.classList.add('is-error')
    }
    if (contactInfo === null ) {
      contactEmail.classList.add('is-error')
      contactPhone.classList.add('is-error')
    }
  
    const path = `/wp-json/tribord/v1/contact?organization=${organization.value}&name=${name.value}&lastname=${lastname.value}&email=${email.value}&phone=${phone.value}&message=${message.value}&rgpd=${rgpd.value}&contact=${contactInfo}`

    if (valid) {
      const data = apiFetch({ path }).then((res) => {
        if (res.success === 'ok') {
          error.style.display = 'none'
          success.style.display = 'block'

          success.innerHTML = 'Message send with success. Thank You !'

          message.value = ''
          name.value = ''
          lastname.value = ''
          email.value = ''
          phone.value = ''
          organization.value = ''
          contact = null
          rgpd.checked = false
          contactEmail.checked = false
          contactPhone.checked = false
        }
      })
    } else {
      error.innerHTML = errors
      error.style.display = 'block'
    }

    return false;
  })
}